import { jsx as s, jsxs as a } from "react/jsx-runtime";
import { d as i, W as l, _ as m } from "../../vendor-CPVnY93G.js";
import { forwardRef as p } from "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as d } from "../../utils/omitStyleRenderProps/index.js";
import { TooltipTrigger as _, Tooltip as u } from "../Tooltip/index.js";
import '../../assets/index12.css';const k = "_link_1tb1q_1", x = "_truncate_1tb1q_10", $ = "_href_1tb1q_28", t = {
  link: k,
  truncate: x,
  href: $
}, j = p(
  ({ children: o, truncate: r = !1, ...e }, c) => {
    const f = i(t.link, {
      [t.href]: !!e.href,
      [t.truncate]: r
    }), n = /* @__PURE__ */ s(
      l,
      {
        ...d(e),
        slot: null,
        ref: c,
        className: f,
        "data-component": "Link",
        children: o
      }
    );
    return r ? /* @__PURE__ */ a(_, { children: [
      n,
      /* @__PURE__ */ s(u, { children: typeof o != "function" ? o : void 0 })
    ] }) : n;
  }
), v = m;
export {
  j as Link,
  v as RouterProvider
};
